import React from 'react';
import '../styles/pages/Services.css';
import '../styles/pages/ServicesCreditScore.css';
import '../styles/GlobalSections.css';

const services = [
   {
    title: 'KYC Verification',
    description: 'Complete Know Your Customer verification services',
    icon: '✅',
    features: ['Aadhaar Verification', 'Address Verification', 'Document Validation', 'Biometric Auth']
  },
  {
    title: 'PAN Verification',
    description: 'Instant PAN card verification and validation services',
    icon: '🆔',
    features: ['Real-time Verification', 'Document Validation', 'Identity Confirmation', 'API Integration']
  },
    {
    title: 'Court Case Check Reports',
    description: 'Comprehensive legal case verification and background checks',
    icon: '⚖️',
    features: ['Civil Cases', 'Criminal Records', 'Pending Litigations', 'Legal History']
  },
  {
    title: 'Fraud analysts',
    description: 'Fraud analysts are the unsung heroes of digital trust. Every day, they fight relentless schemes that evolve faster than most systems can catch. Shufti gives them the fraud detection tools to tip the balance, turning endless alerts into actionable insights so no fraud is missed.',
    icon: '📈',
    features: ['']
  },
  {
    title: 'Age Verification',
    description: 'Age checks can churn valid users down, so how can you serve adults fast without risking minors? Shufti’s privacy-preserving and smart age verification system adapts by age group and business requirement, enabling a waterfall, progressive approach for swift onboarding for 18+ while rigorously guarding access for underage users, fully Challenge 18 & 21 ready.',
    icon: '📋',
    features: ['']
  },
  {
    title: 'Instant business verification',
    description: 'Create trusted business relationships by immediately verifying business information, including addresses, business statements, and Ultimate Beneficial Owners (UBOs). Receive updates when information changes to ensure continuous regulatory compliance with vendor management systems.',
    icon: '📊',
    features: ['']
  },
  {
    title: 'Document verification',
    description: 'Verify any government-issued document types with in-house technology that does not outsource your data. From recursive OCR for non-Latin scripts to handling cropped or worn IDs, Shufti delivers high-assurance decisions in under 15 seconds, so you can onboard users, not just audit them.',
    icon: '🔍',
    features: ['']
  },
];

export default function Services() {
  return (
    <div className="services-page">
      <section className="services-hero">
        <div className="container">
          <h1>Our Services</h1>
          <p>Comprehensive credit KYC verification solutions for modern lending</p>
        </div>
      </section>

      <section className="services-grid-section section-white">
        <div className="container">
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-card">
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <ul className="service-features">
                  {service.features.map((feature, idx) => (
                    <li key={idx}>
                      <span className="feature-check">✓</span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="credit-score-info section-light-blue">
        <div className="container">
          <div className="section-header-center">
            <h2>General information</h2>
            <h3>What is a Credit Score?</h3>
            <p className="credit-score-intro">
              A credit score is a 3-digit number ranging from 300 to 900 that represents your creditworthiness
            </p>
          </div>
          
          <div className="score-ranges">
            <div className="score-range excellent">
              <div className="score-badge">
                <div className="score-number">750+</div>
                <div className="score-label">Excellent</div>
              </div>
              <p className="score-description">Outstanding credit profile with high approval rates</p>
            </div>
            <div className="score-range good">
              <div className="score-badge">
                <div className="score-number">700-749</div>
                <div className="score-label">Good</div>
              </div>
              <p className="score-description">Good credit standing with favorable loan terms</p>
            </div>
            <div className="score-range needs-improvement">
              <div className="score-badge">
                <div className="score-number">Below 650</div>
                <div className="score-label">Needs Improvement</div>
              </div>
              <p className="score-description">Work on improving credit history and payment patterns</p>
            </div>
          </div>

          <div className="credit-factors">
            <h3 className="factors-title">How Credit Score Works</h3>
            <p className="factors-subtitle">Key factors that influence your credit score</p>
            <div className="factors-grid">
              <div className="factor">
                <div className="factor-icon">💳</div>
                <h4>Payment History</h4>
                <p>Most important factor - 35% weightage</p>
              </div>
              <div className="factor">
                <div className="factor-icon">📊</div>
                <h4>Credit Utilization</h4>
                <p>Keep below 30% - 30% weightage</p>
              </div>
              <div className="factor">
                <div className="factor-icon">📅</div>
                <h4>Credit History Length</h4>
                <p>Longer is better - 15% weightage</p>
              </div>
              <div className="factor">
                <div className="factor-icon">🏦</div>
                <h4>Loan & Credit Card Mix</h4>
                <p>Diverse credit types - 10% weightage</p>
              </div>
              <div className="factor">
                <div className="factor-icon">🔍</div>
                <h4>Credit Enquiries</h4>
                <p>Fewer enquiries - 10% weightage</p>
              </div>
            </div>
          </div>

          <div className="credit-check-process">
            <h3 className="process-title">KYC Verifivation Process</h3>
            <p className="process-subtitle">Get your KYC Verifivation in 3 simple steps</p>
            <div className="process-steps">
              <div className="process-step">
                <div className="step-number">1</div>
                <div className="step-content">
                  <h4>Enter Details</h4>
                  <p>Enter basic personal details</p>
                </div>
              </div>
              <div className="process-arrow">→</div>
              <div className="process-step">
                <div className="step-number">2</div>
                <div className="step-content">
                  <h4>Verify</h4>
                  <p>Verify details from Application programming interface</p>
                </div>
              </div>
              <div className="process-arrow">→</div>
              <div className="process-step">
                <div className="step-number">3</div>
                <div className="step-content">
                  <h4>View Report</h4>
                  <p>View Report instantly</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
